
export default function IframePage({ src }) {
  return (
    <iframe
      src={src}
      style={{ width: '100%', height: '100vh', border: 'none' }}
      title="Legal"
    />
  );
}
